import BasicModel from '../basic/BasicModel'
export default {
  findBusinesSelectOption (vm, listener) {
    let action = 'business/findBusinesSelectOption.action'
    BasicModel.get(vm, action, null, listener)
  },
  findBusinesses (vm, params, listener) {
    let action = 'business/findBusinesses.action'
    BasicModel.get(vm, action, params, listener)
  },
  addBusiness (vm, params, listener) {
    let action = 'business/insertBusiness.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateBusiness (vm, params, listener) {
    let action = 'business/updateBusiness.action'
    BasicModel.post(vm, action, params, listener)
  },
  checkExistsBusiness (vm, params, listener) {
    let action = 'business/checkExistsBusiness.action'
    BasicModel.get(vm, action, params, listener)
  },
  innsertApplyBusiness (vm, params, listener) {
    let action = 'business/innsertApplyBusiness.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateBusinessState (vm, params, listener) {
    let action = 'business/updateBusinessState.action'
    BasicModel.post(vm, action, params, listener)
  },
  addBusinessActive (vm, params, listener) {
    let action = 'business/insertBusinessActive.action'
    BasicModel.post(vm, action, params, listener)
  },
  deleteActive (vm, params, listener) {
    let action = 'business/deleteBusinessActive.action'
    BasicModel.post(vm, action, params, listener)
  },
  selectBusinessActiveById (vm, params, listener) {
    let action = 'business/selectBusinessActiveById.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateBusinessActive (vm, params, listener) {
    let action = 'business/updateBusinessActive.action'
    BasicModel.post(vm, action, params, listener)
  },
  stickTopBusiness (vm, params, listener) {
    let action = 'business/stickTop.action'
    BasicModel.post(vm, action, params, listener)
  },
  delBusiness (vm, params, listener) {
    let action = 'business/delBusiness.action'
    BasicModel.post(vm, action, params, listener)
  },
  findAMapLocations (vm, params, listener) {
    let action = 'business/findAMapLocations.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectAreaInfo (vm, params, listener) {
    let action = 'business/selectAreaInfo.action'
    BasicModel.get(vm, action, params, listener)
  },
  setDeviceType (vm, params, listener) {
    let action = 'lcwpbusiness/setDeviceType.action'
    BasicModel.post(vm, action, params, listener)
  },
  setMungBean (vm, params, listener) {
    let action = 'lcwpbusiness/setMungBean.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateRejectedBusiness (vm, params, listener) {
    let action = 'lcwpbusiness/updateRejectedBusiness.action'
    BasicModel.post(vm, action, params, listener)
  }

}
